module.exports = __webpack_public_path__ + "assets/download-monitor.2cec551d.svg";